import {Fancybox} from '@fancyapps/ui';
// eslint-disable-next-line
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('.j-fancybox', {});
